import { ConsumerSupportCaseCategory } from '@consumer/graphql'
import { IssueType } from './types'

// Helper function to map IssueType to ConsumerSupportCaseCategory
export const mapIssueTypeToCaseCategory = (issueType: string): ConsumerSupportCaseCategory => {
  switch (issueType) {
    case IssueType.PACKAGE_DAMAGED:
      return ConsumerSupportCaseCategory.PackageDamaged
    case IssueType.PACKAGE_MISSING:
      return ConsumerSupportCaseCategory.PackageMissing
    case IssueType.DRIVER_MISSED_INSTRUCTIONS:
      return ConsumerSupportCaseCategory.InstructionsNotFollowed
    case IssueType.WRONG_PLACE:
      return ConsumerSupportCaseCategory.WrongPlace
    case IssueType.DELIVERY_DELAYED:
      return ConsumerSupportCaseCategory.DeliveryDelayed
    case IssueType.ORDER_CONTENTS_ISSUE:
      return ConsumerSupportCaseCategory.OrderContentsIssue
    case IssueType.OTHER:
    default:
      return ConsumerSupportCaseCategory.Other
  }
}

// Helper function to map ConsumerSupportCaseCategory to IssueType
export const mapCaseCategoryToIssueType = (caseCategory: ConsumerSupportCaseCategory): IssueType => {
  switch (caseCategory) {
    case ConsumerSupportCaseCategory.PackageDamaged:
      return IssueType.PACKAGE_DAMAGED
    case ConsumerSupportCaseCategory.PackageMissing:
      return IssueType.PACKAGE_MISSING
    case ConsumerSupportCaseCategory.InstructionsNotFollowed:
      return IssueType.DRIVER_MISSED_INSTRUCTIONS
    case ConsumerSupportCaseCategory.WrongPlace:
      return IssueType.WRONG_PLACE
    case ConsumerSupportCaseCategory.DeliveryDelayed:
      return IssueType.DELIVERY_DELAYED
    case ConsumerSupportCaseCategory.OrderContentsIssue:
      return IssueType.ORDER_CONTENTS_ISSUE
    case ConsumerSupportCaseCategory.Other:
    default:
      return IssueType.OTHER
  }
}
